import { render } from "./SensorsComponent.vue?vue&type=template&id=b849815c"
import script from "./SensorsComponent.vue?vue&type=script&lang=js"
export * from "./SensorsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__